import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "swipe-list"
};
import { onMounted, onBeforeUnmount, ref } from "vue";
import SvgIcon from "../base/SvgIcon.vue";
import { useI18n } from "vue-i18n";
export default {
  __name: 'LoopSwipe',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var timer = null;
    var curSwipeIndex = ref(-1);
    var swipeList = ref([t("congratulationForGettingAVoucher", ["T***"]), t("congratulationForGettingAVoucher", ["Y***"]), t("congratulationForGettingAVoucher", ["C***"]), t("congratulationForGettingAVoucher", ["Y***"]), t("congratulationForGettingAVoucher", ["Z***"]), t("congratulationForGettingAVoucher", ["H***"]), t("congratulationForGettingAVoucher", ["Z***"]), t("congratulationForGettingAVoucher", ["X***"]), t("congratulationForGettingAVoucher", ["N***"]), t("congratulationForGettingAVoucher", ["C***"]), t("congratulationForGettingAVoucher", ["Y***"]), t("congratulationForGettingAVoucher", ["X***"])]);
    function loop() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var curIndex = curSwipeIndex.value;
      curSwipeIndex.value = -1;
      timer = setTimeout(function () {
        curSwipeIndex.value = (curIndex + 1) % swipeList.value.length;
        timer = setTimeout(function () {
          loop();
        }, 3800);
      }, immediate ? 0 : 800);
    }
    onMounted(function () {
      loop(true);
    });
    onBeforeUnmount(function () {
      clearTimeout(timer);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SvgIcon, {
        name: "notify",
        size: 16
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swipeList.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "swipe-item"
        }, [_createVNode(_Transition, {
          name: "slide-up"
        }, {
          default: _withCtx(function () {
            return [_withDirectives(_createElementVNode("div", null, _toDisplayString(item), 513), [[_vShow, index === curSwipeIndex.value]])];
          }),
          _: 2
        }, 1024)]);
      }), 128))]);
    };
  }
};